import(/* webpackMode: "eager" */ "/var/directorder/app/staging/apps/seller/src/app/(auth)/login/[[...mode]]/page.js");
